/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InspectRouteImport } from './routes/inspect'
import { Route as InspectIndexRouteImport } from './routes/inspect/index'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as RecommendationsIndexRouteImport } from './routes/recommendations/index'
import { Route as InspectDbIndexRouteImport } from './routes/inspect/$db/index'
import { Route as InspectDbCollRouteImport } from './routes/inspect/$db/$coll'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectRoute = InspectRouteImport.update({
  id: '/inspect',
  path: '/inspect',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectIndexRoute = InspectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InspectRoute,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationsIndexRoute = RecommendationsIndexRouteImport.update({
  id: '/recommendations/',
  path: '/recommendations/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectDbIndexRoute = InspectDbIndexRouteImport.update({
  id: '/$db/',
  path: '/$db/',
  getParentRoute: () => InspectRoute,
} as any)
const InspectDbCollRoute = InspectDbCollRouteImport.update({
  id: '/$db/$coll',
  path: '/$db/$coll',
  getParentRoute: () => InspectRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/inspect': typeof InspectRouteWithChildren
  '/inspect/': typeof InspectIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/recommendations/': typeof RecommendationsIndexRoute
  '/inspect/$db/$coll': typeof InspectDbCollRoute
  '/inspect/$db/': typeof InspectDbIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inspect': typeof InspectIndexRoute
  '/jobs': typeof JobsIndexRoute
  '/recommendations': typeof RecommendationsIndexRoute
  '/inspect/$db/$coll': typeof InspectDbCollRoute
  '/inspect/$db': typeof InspectDbIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/inspect': typeof InspectRouteWithChildren
  '/inspect/': typeof InspectIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/recommendations/': typeof RecommendationsIndexRoute
  '/inspect/$db/$coll': typeof InspectDbCollRoute
  '/inspect/$db/': typeof InspectDbIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/inspect'
    | '/inspect/'
    | '/jobs/'
    | '/recommendations/'
    | '/inspect/$db/$coll'
    | '/inspect/$db/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/inspect'
    | '/jobs'
    | '/recommendations'
    | '/inspect/$db/$coll'
    | '/inspect/$db'
  id:
    | '__root__'
    | '/'
    | '/inspect'
    | '/inspect/'
    | '/jobs/'
    | '/recommendations/'
    | '/inspect/$db/$coll'
    | '/inspect/$db/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InspectRoute: typeof InspectRouteWithChildren
  JobsIndexRoute: typeof JobsIndexRoute
  RecommendationsIndexRoute: typeof RecommendationsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspect': {
      id: '/inspect'
      path: '/inspect'
      fullPath: '/inspect'
      preLoaderRoute: typeof InspectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspect/': {
      id: '/inspect/'
      path: '/'
      fullPath: '/inspect/'
      preLoaderRoute: typeof InspectIndexRouteImport
      parentRoute: typeof InspectRoute
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendations/': {
      id: '/recommendations/'
      path: '/recommendations'
      fullPath: '/recommendations/'
      preLoaderRoute: typeof RecommendationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspect/$db/': {
      id: '/inspect/$db/'
      path: '/$db'
      fullPath: '/inspect/$db/'
      preLoaderRoute: typeof InspectDbIndexRouteImport
      parentRoute: typeof InspectRoute
    }
    '/inspect/$db/$coll': {
      id: '/inspect/$db/$coll'
      path: '/$db/$coll'
      fullPath: '/inspect/$db/$coll'
      preLoaderRoute: typeof InspectDbCollRouteImport
      parentRoute: typeof InspectRoute
    }
  }
}

interface InspectRouteChildren {
  InspectIndexRoute: typeof InspectIndexRoute
  InspectDbCollRoute: typeof InspectDbCollRoute
  InspectDbIndexRoute: typeof InspectDbIndexRoute
}

const InspectRouteChildren: InspectRouteChildren = {
  InspectIndexRoute: InspectIndexRoute,
  InspectDbCollRoute: InspectDbCollRoute,
  InspectDbIndexRoute: InspectDbIndexRoute,
}

const InspectRouteWithChildren =
  InspectRoute._addFileChildren(InspectRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InspectRoute: InspectRouteWithChildren,
  JobsIndexRoute: JobsIndexRoute,
  RecommendationsIndexRoute: RecommendationsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
